import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyHtml, renderStandardPictureElement } from "../../../utils";

export default {
    title: "Website/Partial Templates/Company Info",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        additionalInfo: 2,
    },
    argTypes: {
        additionalInfo: {
            control: {
                type: "range",
                min: 0,
                max: 3,
                step: 1,
            },
        },
    },
};

const Template = (args) => {
    return html`
        <div class="ux-t-container">
            <div class="ux-u-shadow">
                <div class="ux-row">
                    <div class="ux-col-10 ux-u-offset-1">
                        <div
                            class="ux-row ux-u-border-bottom ux-u-pt-fluid-xs ux-u-pb-fluid-xs"
                        >
                            <div class="ux-col-4 ux-u-d-none ux-u-d-md-block">
                                <div class="ux-u-mb-fluid-xxxs">
                                    ${renderStandardPictureElement({
                                        width: 708,
                                        height: 472,
                                    })}
                                </div>
                            </div>
                            <div class="ux-col-12 ux-col-md-8">
                                <h2
                                    class="ux-text-headline ux-text-headline--big ux-u-text-bold ux-u-my-zero"
                                >
                                    Company Info module
                                </h2>
                                <a
                                    class="ux-text-link ux-text-link--green ux-u-d-block ux-u-mb-xxxs"
                                    target="_blank"
                                    href="#"
                                >
                                    <span>www.company-info.com</span>
                                </a>
                                <div class="ux-u-mb-fluid-xxxs ux-u-d-md-none">
                                    ${renderStandardPictureElement({
                                        width: 708,
                                        height: 472,
                                    })}
                                </div>
                                <div class="ux-text-normal">
                                    ${getDummyHtml()}
                                </div>
                            </div>
                        </div>
                        <div class="ux-row ux-u-pt-fluid-xs ux-u-pb-fluid-xs">
                            <div class="ux-col-12 ux-col-md-4">
                                <ux-iws-teaser-sidebar-icon
                                    class="ux-u-mb-xs ux-u-my-md-zero ux-u-py-zero"
                                    content-element
                                >
                                    <ux-icon
                                        name="earth-generic"
                                        slot="icon"
                                    ></ux-icon>
                                    <div
                                        slot="link"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                    >
                                        Industrie
                                    </div>
                                    <div class="ux-text-normal">
                                        Automobilbranche
                                    </div>
                                </ux-iws-teaser-sidebar-icon>
                            </div>
                            <div class="ux-col-12 ux-col-md-4">
                                <ux-iws-teaser-sidebar-icon
                                    class="ux-u-mb-xs ux-u-my-md-zero ux-u-py-zero"
                                    content-element
                                >
                                    <ux-icon
                                        name="earth-generic"
                                        slot="icon"
                                    ></ux-icon>
                                    <div
                                        slot="link"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                    >
                                        Standort
                                    </div>
                                    <div class="ux-text-normal">
                                        Stuttgart, Deutschland
                                    </div>
                                </ux-iws-teaser-sidebar-icon>
                            </div>
                            <div class="ux-col-12 ux-col-md-4">
                                <ux-iws-teaser-sidebar-icon
                                    class="ux-u-my-zero ux-u-py-zero"
                                    content-element
                                >
                                    <ux-icon
                                        name="earth-generic"
                                        slot="icon"
                                    ></ux-icon>
                                    <div
                                        slot="link"
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                    >
                                        Grosse
                                    </div>
                                    <div class="ux-text-normal">
                                        78.000 Mitarbeiter
                                    </div>
                                </ux-iws-teaser-sidebar-icon>
                            </div>
                        </div>
                        ${args.additionalInfo > 0
                            ? html` <div class="ux-row ux-u-pb-fluid-xs">
                                  <div class="ux-col">
                                      <ux-collapsible
                                          button-text-collapsed="Details einblenden"
                                          button-text-expanded="Details ausblenden"
                                          centered-button
                                          is-expanded="false"
                                      >
                                          <div
                                              class="ux-row ux-u-flex-jc-md-evenly ux-u-border-top ux-u-pt-fluid-xs ux-u-pb-fluid-xs"
                                          >
                                              <div
                                                  class="ux-col-12 ux-col-md-auto"
                                              >
                                                  <span
                                                      class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                                      >Products</span
                                                  >
                                                  <ul
                                                      class="ux-list ux-list--green-squares"
                                                  >
                                                      <li>Item 1</li>
                                                      <li>Item 2</li>
                                                  </ul>
                                              </div>
                                              ${args.additionalInfo >= 2
                                                  ? html` <div
                                                        class="ux-col-12 ux-col-md-auto"
                                                    >
                                                        <span
                                                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                                            >Machines</span
                                                        >
                                                        <ul
                                                            class="ux-list ux-list--green-squares"
                                                        >
                                                            <li>Item 1</li>
                                                            <li>Item 2</li>
                                                        </ul>
                                                    </div>`
                                                  : html``}
                                              ${args.additionalInfo >= 3
                                                  ? html` <div
                                                        class="ux-col-12 ux-col-md-auto"
                                                    >
                                                        <span
                                                            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                                            >Machines</span
                                                        >
                                                        <ul
                                                            class="ux-list ux-list--green-squares"
                                                        >
                                                            <li>Item 1</li>
                                                            <li>Item 2</li>
                                                        </ul>
                                                    </div>`
                                                  : html``}
                                          </div>
                                      </ux-collapsible>
                                  </div>
                              </div>`
                            : html``}
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const Default = Template.bind({});
